/**
 * Custom MapTiler Control for Map Style Selector
 * Implements the IControl interface to integrate with MapTiler's control system
 */
export class MapStyleControl {
  constructor({ overlayRef, buttonRef }) {
    this.overlayRef = overlayRef;
    this.buttonRef = buttonRef;
  }

  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group';
    this._container.style.cssText = 'margin: 10px;';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'maplibregl-ctrl-icon';
    button.setAttribute('aria-label', 'Map style');
    button.style.cssText = `
      width: 33px;
      height: 40px;
      border-radius: 4px;
      background: white;
      border: 1px solid rgba(0,0,0,0.1);
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `;

    const icon = document.createElement('i');
    icon.className = 'pi pi-map';
    icon.style.cssText = 'font-size: 18px; color: #333;';
    button.appendChild(icon);

    button.addEventListener('click', (e) => {
      e.stopPropagation();
      if (this.overlayRef?.current) {
        this.overlayRef.current.toggle(e);
      }
    });

    this._container.appendChild(button);

    // Store button reference for overlay attachment
    if (this.buttonRef) {
      this.buttonRef.current = button;
    }

    return this._container;
  }

  onRemove() {
    if (this._container && this._container.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }
    if (this.buttonRef) {
      this.buttonRef.current = null;
    }
    this._map = undefined;
  }

  getDefaultPosition() {
    return 'top-right';
  }
}
